import React, { ReactNode } from 'react';
import { css } from '@emotion/core';

const iconSizeProps = {
  xsmall: 15,
  small: 20,
  xmedium: 30,
  medium: 40,
  large: 60,
};

type IconProps = {
  color?: string;
  size?: string;
  viewBox?: number;
  children?: ReactNode;
};

export const Icon: React.FC<IconProps> = ({ color, size, children, viewBox, ...rest }) => {
  const style = {
    width: `${iconSizeProps[size]}px`,
    height: `${iconSizeProps[size]}px`,
    '&:hover': {
      opacity: 0.7,
    },
    transition: 'all 0.3s ease-in-out',
  };
  let ratioViewBox = 0.845;
  if (size === 'medium') {
    ratioViewBox = 1.7;
  }
  if (size === 'xsmall') {
    ratioViewBox = 0.63;
  }
  if (size === 'xmedium') {
    ratioViewBox = 1.2;
  }
  const viewbox = viewBox ? viewBox : iconSizeProps[size] / ratioViewBox;
  return (
    <div style={{ ...style }} {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={color}
        viewBox={`0 0 ${viewbox} ${viewbox}`}
        preserveAspectRatio="xMinYMin slice"
      >
        {children}
      </svg>
    </div>
  );
};
